import {IHttpService, IQService} from 'angular';
import {deriveDefaultLkz, formatPhoneNumber, parseAreaCodeCsv, resolveLkz} from '../utils/PhoneNumberFormatter';

const SUPPORTED_LKZS: {[lkz: string]: boolean} = {'49': true, '41': true, '1': true, '43': true};

export class PhoneNumberFormatterService {
    public static $inject = ['$http', '$q'];
    private areaCodePromises: {[lkz: string]: ng.IPromise<string[]>} = {};

    constructor(private $http: IHttpService, private $q: IQService) {
    }

    public format(rawNumber: string, mobileNumber: string): ng.IPromise<string> {
        const defaultLkz = deriveDefaultLkz(mobileNumber);
        const lkz = resolveLkz(rawNumber.trim(), defaultLkz);
        return this.loadAreaCodes(lkz).then((areaCodes: string[]) =>
            formatPhoneNumber(rawNumber, defaultLkz, areaCodes));
    }

    private loadAreaCodes(lkz: string | null): ng.IPromise<string[]> {
        if (!lkz || !SUPPORTED_LKZS[lkz]) {
            return this.$q.when([]);
        }
        if (!this.areaCodePromises[lkz]) {
            this.areaCodePromises[lkz] = this.$http.get('vorwahlen_' + lkz + '.csv', {cache: true})
                .then((response: ng.IHttpResponse<string>) => parseAreaCodeCsv(response.data))
                .catch(() => {
                    delete this.areaCodePromises[lkz];
                    return [];
                });
        }
        return this.areaCodePromises[lkz];
    }
}
